import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-shadow',
  templateUrl: './magic-uses-shadow.component.html',
  styleUrls: ['./magic-uses-shadow.component.css']
})
export class MagicUsesShadowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
